import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth-guard';
import { guestGuard } from './core/guards/guest-guard';
import { organizationGuard } from './core/guards/organization-guard';

export const routes: Routes = [
  {
    path: 'aceitar-convite',
    loadComponent: () =>
      import('./features/auth/invitation-redirect/invitation-redirect').then(
        (m) => m.InvitationRedirect,
      ),
  },

  {
    path: '',
    canActivate: [guestGuard],
    loadComponent: () => import('./core/layout/auth-layout').then((m) => m.AuthLayout),
    children: [
      {
        path: '',
        loadComponent: () => import('./features/auth/login/login').then((m) => m.Login),
      },
      {
        path: 'registrar',
        loadComponent: () => import('./features/auth/register/register').then((m) => m.Register),
      },
      {
        path: 'recuperar-senha',
        loadComponent: () =>
          import('./features/auth/password-recovery/password-recovery').then(
            (m) => m.PasswordRecovery,
          ),
      },
      {
        path: 'resetar-senha',
        loadComponent: () =>
          import('./features/auth/reset-password/reset-password').then((m) => m.ResetPassword),
      },
    ],
  },

  {
    path: 'dashboard/onboarding',
    loadComponent: () => import('./features/auth/onboarding/onboarding').then((m) => m.Onboarding),
    canActivate: [authGuard],
  },

  {
    path: 'dashboard/organizacoes/nova',
    loadComponent: () =>
      import('./features/auth/organization-create/organization-create').then(
        (m) => m.OrganizationCreate,
      ),
    canActivate: [authGuard],
  },

  {
    path: ':org/acesso',
    loadComponent: () =>
      import('./features/auth/organization-access/organization-access').then(
        (m) => m.OrganizationAccess,
      ),
    canActivate: [authGuard],
  },

  {
    path: ':org/dashboard',
    loadComponent: () => import('./core/layout/dashboard-layout').then((m) => m.DashboardLayout),
    canActivate: [authGuard, organizationGuard],
    runGuardsAndResolvers: 'paramsChange',
    children: [
      {
        path: '',
        loadComponent: () => import('./features/dashboard/home/home').then((m) => m.Home),
      },
      {
        path: 'novidades',
        loadComponent: () =>
          import('./features/dashboard/release-notes/release-notes').then(
            (m) => m.ReleaseNotesComponent,
          ),
      },
      {
        path: 'membros',
        loadComponent: () =>
          import('./features/dashboard/members/list/members').then((m) => m.Members),
      },
      {
        path: 'clientes',
        loadComponent: () =>
          import('./features/dashboard/clients/list/clients').then((m) => m.ClientsComponent),
      },
      {
        path: 'clientes/:clientId',
        loadComponent: () =>
          import('./features/dashboard/clients/detail/client-detail').then(
            (m) => m.ClientDetailComponent,
          ),
      },
      {
        path: 'audits',
        loadComponent: () => import('./features/dashboard/audits/audits').then((m) => m.Audits),
      },
      {
        path: 'financeiro/faturas',
        loadComponent: () =>
          import('./features/dashboard/invoices/list/invoice-list').then((m) => m.InvoicesList),
      },
      {
        path: 'faturas-clientes',
        loadComponent: () =>
          import('./features/dashboard/client-invoices/client-invoices').then(
            (m) => m.ClientInvoices,
          ),
      },
      {
        path: 'pontos',
        loadComponent: () =>
          import('./features/dashboard/points/list/points-list').then((m) => m.PointsList),
      },
      {
        path: 'pontos/gpon/:point_id',
        loadComponent: () => import('./features/dashboard/gpon/gpon').then((m) => m.GponComponent),
      },
      {
        path: 'gpon',
        loadComponent: () => import('./features/dashboard/gpon/gpon').then((m) => m.GponComponent),
      },
      {
        path: 'gpon-alarmes',
        loadComponent: () =>
          import('./features/dashboard/gpon-alarm/gpon-alarm').then((m) => m.GponAlarmComponent),
      },
      {
        path: 'vlan',
        loadComponent: () => import('./features/dashboard/vlan/vlan').then((m) => m.VlanComponent),
      },
      {
        path: 'service-port',
        loadComponent: () =>
          import('./features/dashboard/service-port/service-port').then(
            (m) => m.ServicePortComponent,
          ),
      },
      {
        path: 'onts',
        loadComponent: () =>
          import('./features/dashboard/ont-list/ont-list').then((m) => m.OntListComponent),
      },
      {
        path: 'pontos/ittv/:point_id',
        loadComponent: () =>
          import('./features/dashboard/points-ittv/edit/point-ittv-edit').then(
            (m) => m.PointIttvEdit,
          ),
      },
      {
        path: 'produtos',
        loadComponent: () =>
          import('./features/dashboard/products/list/products').then((m) => m.ProductsComponent),
      },
      {
        path: 'labels',
        loadComponent: () =>
          import('./features/dashboard/labels/labels').then((m) => m.LabelsComponent),
      },
      {
        path: 'equipamentos',
        loadComponent: () =>
          import('./features/dashboard/equipment/list/equipment-list').then(
            (m) => m.EquipmentListComponent,
          ),
      },
      {
        path: 'equipamentos/atribuicao',
        loadComponent: () =>
          import('./features/dashboard/equipment/handoff/equipment-handoff').then(
            (m) => m.EquipmentHandoffComponent,
          ),
      },
      {
        path: 'equipamentos/modelos',
        loadComponent: () =>
          import('./features/dashboard/equipment/models/equipment-models').then(
            (m) => m.EquipmentModelsComponent,
          ),
      },
      {
        path: 'produtos/produtos-compartilhados',
        loadComponent: () =>
          import('./features/dashboard/products/shared-products-list/shared-products-list').then(
            (m) => m.SharedProductsList,
          ),
      },
      {
        path: 'net/pontos',
        loadComponent: () =>
          import('./features/dashboard/points/list/points-list').then((m) => m.PointsList),
      },
      {
        path: 'net/pontos/gpon/:point_id',
        loadComponent: () => import('./features/dashboard/gpon/gpon').then((m) => m.GponComponent),
      },
      {
        path: 'net/pontos/ittv/:point_id',
        loadComponent: () =>
          import('./features/dashboard/points-ittv/edit/point-ittv-edit').then(
            (m) => m.PointIttvEdit,
          ),
      },
      {
        path: 'net/produtos',
        loadComponent: () =>
          import('./features/dashboard/products/list/products').then((m) => m.ProductsComponent),
      },
      {
        path: 'net/olts/saude',
        loadComponent: () =>
          import('./features/dashboard/olt-health/olt-health').then((m) => m.OltHealth),
      },
      {
        path: 'net/olts',
        loadComponent: () =>
          import('./features/dashboard/olt-list/olt-list').then((m) => m.OltListComponent),
      },
      {
        path: 'radius/sessoes',
        loadComponent: () =>
          import('./features/dashboard/radius-sessions/radius-sessions').then(
            (m) => m.RadiusSessionsComponent,
          ),
      },
      {
        path: 'radius/pos-autenticacao',
        loadComponent: () =>
          import('./features/dashboard/radius-postauth/radius-postauth').then(
            (m) => m.RadiusPostauthComponent,
          ),
      },
      {
        path: 'radius/mikrotik/sessoes',
        loadComponent: () =>
          import('./features/dashboard/mikrotik/sessions/mikrotik-sessions').then(
            (m) => m.MikrotikSessionsComponent,
          ),
      },
      {
        path: 'configuracoes/organizacao',
        loadComponent: () =>
          import('./features/dashboard/organization-settings/organization-settings').then(
            (m) => m.OrganizationSettingsComponent,
          ),
      },
      {
        path: 'configuracoes/conta',
        loadComponent: () =>
          import('./features/dashboard/account-settings/account-settings').then(
            (m) => m.AccountSettingsComponent,
          ),
      },
      {
        path: 'assinaturas',
        loadComponent: () =>
          import('./features/dashboard/subscriptions/subscriptions').then(
            (m) => m.SubscriptionsComponent,
          ),
      },
      {
        path: 'chamados',
        loadComponent: () =>
          import('./features/dashboard/tickets/list/tickets').then((m) => m.TicketsComponent),
      },
      {
        path: 'chamados/:ticketId',
        loadComponent: () =>
          import('./features/dashboard/tickets/detail/ticket-detail').then(
            (m) => m.TicketDetailComponent,
          ),
      },
      {
        path: 'ordens-de-servico/minhas-atividades',
        loadComponent: () =>
          import('./features/dashboard/service-orders/my-activities/service-orders-my-activities').then(
            (m) => m.ServiceOrdersMyActivitiesComponent,
          ),
      },
      {
        path: 'ordens-de-servico',
        loadComponent: () =>
          import('./features/dashboard/service-orders/list/service-orders').then(
            (m) => m.ServiceOrdersComponent,
          ),
      },
      {
        path: 'mensageria/notificacoes',
        loadComponent: () =>
          import('./features/dashboard/messaging/notifications/messaging-notifications').then(
            (m) => m.MessagingNotificationsComponent,
          ),
      },
      {
        path: 'mensageria/uso',
        loadComponent: () =>
          import('./features/dashboard/messaging/usage/messaging-usage').then(
            (m) => m.MessagingUsageComponent,
          ),
      },
      {
        path: 'mensageria/templates',
        loadComponent: () =>
          import('./features/dashboard/messaging/templates/list/messaging-templates').then(
            (m) => m.MessagingTemplatesComponent,
          ),
      },
      {
        path: 'mensageria/templates/:templateId',
        loadComponent: () =>
          import('./features/dashboard/messaging/templates/form/messaging-template-form').then(
            (m) => m.MessagingTemplateFormComponent,
          ),
      },
      {
        path: 'contratos',
        loadComponent: () =>
          import('./features/dashboard/contracts/list/contracts-list').then(
            (m) => m.ContractsListComponent,
          ),
      },
      {
        path: 'contratos/templates',
        loadComponent: () =>
          import('./features/dashboard/contracts/templates/list/contract-templates').then(
            (m) => m.ContractTemplatesComponent,
          ),
      },
      {
        path: 'contratos/templates/:templateId',
        loadComponent: () =>
          import('./features/dashboard/contracts/templates/form/contract-template-form').then(
            (m) => m.ContractTemplateFormComponent,
          ),
      },
      {
        path: 'contratos/:contractId',
        loadComponent: () =>
          import('./features/dashboard/contracts/view/contract-view').then(
            (m) => m.ContractViewComponent,
          ),
      },
      {
        path: 'topologia',
        loadComponent: () =>
          import('./features/dashboard/isp-topology/access-shell/isp-topology-access-shell').then(
            (m) => m.IspTopologyAccessShell,
          ),
      },
      {
        path: 'conectividade',
        runGuardsAndResolvers: 'paramsOrQueryParamsChange',
        canDeactivate: [
          (component: { canLeaveLocationReview: () => Promise<boolean> }) =>
            component.canLeaveLocationReview(),
        ],
        loadComponent: () =>
          import('./features/dashboard/connectivity-map/connectivity-map').then(
            (m) => m.ConnectivityMap,
          ),
      },
      {
        path: 'net/disponibilidade',
        loadComponent: () =>
          import('./features/dashboard/availability/availability').then(
            (m) => m.AvailabilityComponent,
          ),
      },
    ],
  },
  {
    path: '**',
    loadComponent: () => import('./features/not-found/not-found').then((m) => m.NotFound),
  },
];
